export class JsonContentUtil {

    public static retrieveValue(key: string, content: any): any {
        if(content) {
            const val = content[key];
            return val && val.length > 1 ? val : val[0];
        }
        return null;
    }
}